import { useState } from "react";
import { NotifyPopup } from "./NotifyPopup";

export function Contact() {
  const [showNotify, setShowNotify] = useState(false);
  const [notifyData, setNotifyData] = useState({ title: "", message: "" });

  const handleSubmit = async (e) => {
    e.preventDefault();

    const form = e.target;
    const formData = {
      name: form.name.value,
      email: form.email.value,
      message: form.message.value,
    };

    try {
      const res = await fetch("/api/sendEmail", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      const result = await res.json();

      setNotifyData({
        title: res.ok ? "Sukces" : "Błąd",
        message: res.ok
          ? "Wysłano wiadomość e-mail!"
          : "Błąd przy wysyłaniu wiadomości.",
      });
      setShowNotify(true);
    } catch (err) {
      console.error("Error:", err);
      setNotifyData({
        title: "Błąd",
        message: "Nie można wysłać wiadomości e-mail!",
      });
      setShowNotify(true);
    }
  };

  return (
    <div className="px-4 max-w-lg mx-auto">
      <h1 className="text-5xl text-white font-bold text-center mb-8">
        ZRÓBMY COŚ RAZEM
      </h1>

      <form className="flex flex-col gap-6" onSubmit={handleSubmit}>
        <input
          name="name"
          type="text"
          placeholder="Imię"
          className="bg-input text-white rounded-md px-4 py-3 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-600"
          required
        />

        <input
          name="email"
          type="email"
          placeholder="Email"
          className="bg-input text-white rounded-md px-4 py-3 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-600"
          required
        />

        <textarea
          name="message"
          placeholder="Wiadomość"
          rows={6}
          className="bg-input text-white rounded-md px-4 py-3 placeholder-gray-400 resize-none focus:outline-none focus:ring-2 focus:ring-blue-600"
          required
        />

        <button
          type="submit"
          className="bg-blue-600 hover:bg-blue-700 transition text-white font-semibold rounded-md py-3"
        >
          WYŚLIJ
        </button>
      </form>

      <br />
      <br />

      {showNotify && (
        <NotifyPopup
          title={notifyData.title}
          message={notifyData.message}
          duration={5000}
          onClose={() => setShowNotify(false)}
        />
      )}
    </div>
  );
}
